var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-base-card',{staticClass:"flex w-full flex-col gap-3 p-6"},[_c('div',{staticClass:"flex items-start justify-between md:flex-row",class:{ 'flex-row': _vm.compact, 'flex-col': !_vm.compact }},[_vm._t("header")],2),_c('div',{staticClass:"text-sm text-gray-30"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }